import { memo, useEffect } from "react";

import { Container } from "@material-ui/core";

import DashboardHeaderModule from "./children/DashboardHeaderModule";
import ModalDashBoardFilter from "./children/ModalDashBoardFilter";
import RenderAccordionsDashBoard from "./children/RenderAccordionsDashBoard";
import { DashBoardFinanceiroContextProvider } from "./contexts/DashBoardFinanceiroContext";
import useDashBoardController from "./controllers/DashBoardController";
var verifyedPermissions = false;

const View = () => {
  const { verifyAccessDashs, handleOpenModal } = useDashBoardController();

  useEffect(() => {
    if (!verifyedPermissions) {
      verifyedPermissions = true;
      verifyAccessDashs(["financeiro"]);
    }
  }, [verifyAccessDashs]);
  return (
    <>
      <DashboardHeaderModule action={handleOpenModal} />

      <Container style={{ marginTop: "80px" }} maxWidth="xl">
        <ModalDashBoardFilter />
        <RenderAccordionsDashBoard />
      </Container>
    </>
  );
};

const DashFinanceiro = () => (
  <DashBoardFinanceiroContextProvider>
    <View />
  </DashBoardFinanceiroContextProvider>
);
export default memo(DashFinanceiro);
